import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import FeaturedWorks from './components/FeaturedWorks';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import { useScrollToTop } from '@/hooks/useScrollToTop';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '原神本子精选 — 首页',
  description: '探索海量原神同人创作，涵盖各大角色同人漫画、插画本、小说本等丰富内容。为原神同人爱好者提供最全面的资讯与推荐平台。',
  url: 'https://artsygen.github.io',
  isPartOf: {
    '@type': 'WebSite',
    name: '原神本子精选',
    url: 'https://artsygen.github.io',
  },
  mainEntity: {
    '@type': 'Organization',
    name: '原神本子精选',
    url: 'https://artsygen.github.io',
    description: '原神同人创作精选推荐与交流平台',
  },
};

export default function Home() {
  useScrollToTop();

  return (
    <>
      <SEOHead
        title="精选同人创作合集推荐"
        description="原神本子精选同人创作合集推荐平台，探索海量原神本子创作，涵盖各大角色同人漫画、插画本、小说本等丰富内容。为原神同人爱好者提供最全面的原神本子资讯、推荐与创作交流平台，发现更多高质量同人作品。"
        keywords="原神本子,原神同人本,原神同人漫画,原神角色同人,原神同人插画,原神创作合集,原神二次创作"
        canonicalUrl="https://artsygen.github.io"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedWorks />
        <CategoryGrid />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}